module.exports = __webpack_public_path__ + "img/invest4.16c3707d.jpeg";